"use client";

import { useEffect, useState } from "react";

export function useIsMobile(breakpoint: number = 768) {
	const canUseWindow = typeof window !== "undefined";
	const [isMobile, setIsMobile] = useState(() =>
		canUseWindow ? window.innerWidth < breakpoint : false,
	);
	const [isHydrated, setIsHydrated] = useState(canUseWindow);

	useEffect(() => {
		setIsHydrated(true);

		const checkIsMobile = () => {
			setIsMobile(window.innerWidth < breakpoint);
		};

		// Initial check
		checkIsMobile();

		// Add event listener
		window.addEventListener("resize", checkIsMobile);

		// Cleanup
		return () => window.removeEventListener("resize", checkIsMobile);
	}, [breakpoint]);

	return { isMobile, isHydrated };
}
